<div class="container">
  <div class="title">Timesheets Activities Overview</div>

  <div class="filters-container">
    <mat-form-field appearance="outline">
      <mat-label>Activities Date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input
          [value]="startDate()"
          (dateChange)="startDate.set($event.value!)"
          matStartDate
        />
        <input
          [value]="endDate()"
          (dateChange)="endDate.set($event.value!)"
          matEndDate
        />
      </mat-date-range-input>
      <mat-datepicker-toggle
        [for]="picker"
        matIconSuffix
      ></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Inspection ID</mat-label>
      <input
        [value]="inspectionId()"
        (input)="inspectionId.set($event.target.value)"
        matInput
      />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Contract Local Number</mat-label>
      <input
        [value]="inspectionContractLocalNumber()"
        [maxLength]="10"
        (input)="inspectionContractLocalNumber.set($event.target.value)"
        matInput
      />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Inspector</mat-label>
      <input
        [value]="inspectorSearchText()"
        [matAutocomplete]="inspectorAuto"
        (input)="inspectorSearchText.set($event.target.value)"
        (focus)="inspectorSearchText.set('')"
        type="text"
        matInput
      />
      <mat-autocomplete
        #inspectorAuto="matAutocomplete"
        [displayWith]="displayInspectorName"
        (optionSelected)="
          selectedTeamInspector.set($event.option.value);
          inspectorSearchText.set($event.option.value.name)
        "
        (closed)="onInspectorAutocompleteClosed()"
      >
        @for (
          teamInspector of filteredTeamInspectorCatalog();
          track teamInspector.id
        ) {
          <mat-option [value]="teamInspector">
            @if (teamInspector.isTeam) {
              <mat-icon>groups</mat-icon>
            }
            {{ teamInspector.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Activities</mat-label>
      <mat-select
        [value]="selectedActivity()"
        (selectionChange)="selectedActivity.set($event.value)"
      >
        @for (activity of activities(); track activity.id) {
          <mat-option [value]="activity.id">{{ activity.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select
        [value]="selectedStatus()"
        (selectionChange)="selectedStatus.set($event.value)"
      >
        @for (status of statuses(); track status) {
          <mat-option [value]="status">{{ getStatusLabel(status) }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <button
      class="aligned-button"
      (click)="search()"
      matButton="outlined"
      color="primary"
    >
      <mat-icon>search</mat-icon>
      SEARCH
    </button>
    <button class="aligned-button" (click)="clear()" matButton color="primary">
      CLEAR
    </button>
  </div>

  <div class="secondary-container">
    <button
      class="add-button"
      (click)="addNewTimesheetActivity()"
      matButton="filled"
      color="primary"
    >
      <mat-icon>add</mat-icon>
      ADD NEW EVENT
    </button>

    @if (isSynching()) {
      <mat-icon class="state-icon saving-state" matTooltip="Synching..."
        >cloud_sync</mat-icon
      >
    } @else {
      <mat-icon class="state-icon done-state" matTooltip="Synched data"
        >cloud_done</mat-icon
      >
    }
  </div>

  <div class="table-container">
    <mat-table
      #matTable
      #tableSort="matSort"
      [dataSource]="datasource()"
      (matSortChange)="onSortChange($event)"
      (scroll)="onTableScroll($event)"
      mat-table
      matSort
      matSortDisableClear
    >
      <ng-container matColumnDef="checkbox">
        <th *matHeaderCellDef mat-header-cell>
          <mat-checkbox
            [disabled]="true"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          >
          </mat-checkbox>
        </th>
        <td *matCellDef="let element" mat-cell>
          <mat-checkbox
            [disabled]="
              !selection.isSelected(element) && selection.selected.length >= 10
            "
            [checked]="selection.isSelected(element)"
            (keyPress)="$event.stopPropagation()"
            (click)="$event.stopPropagation()"
            (keydown.space)="
              $event.stopPropagation(); selection.toggle(element)
            "
            (change)="$event ? selection.toggle(element) : null"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="date">
        <th
          class="header-label"
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
        >
          Date
        </th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field
            [ngClass]="{
              'error-color':
                element.validityError ==
                TimesheetActivityError.InvalidDateDueToTimeOff,
            }"
            appearance="outline"
            subscriptSizing="dynamic"
          >
            <input
              [(ngModel)]="element.date"
              [disabled]="isRowLocked(element)"
              [matDatepicker]="picker"
              [matDatepickerFilter]="filterFutureDates"
              (dateChange)="
                changeAllSelectedRows(element, 'date');
                checkValidityAndSave(i, 'date')
              "
              matInput
            />
            <mat-datepicker-toggle
              [for]="picker"
              matIconSuffix
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="inspectionId">
        <th class="header-label" *matHeaderCellDef mat-header-cell>
          Inspection ID
        </th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              [(ngModel)]="element.externalId"
              [disabled]="
                isRowLocked(element) ||
                (selection.hasValue() && selection.isSelected(element))
              "
              (input)="emptyCellValue(element, 'activityId')"
              (blur)="
                searchActivityValuesAndAddToCache(element);
                checkValidityAndSave(i, 'externalId')
              "
              matInput
            />
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="inspectionContractLocalNumber">
        <th class="header-label" *matHeaderCellDef mat-header-cell>
          Contract Local Number
        </th>
        <td *matCellDef="let element" mat-cell>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              [(ngModel)]="element.inspectionContractLocalNumber"
              [disabled]="true"
              matInput
            />
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="inspector">
        <th class="header-label" *matHeaderCellDef mat-header-cell>
          Inspector
        </th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              [value]="
                getRowInspectorSearchValue(element.id, element.userEmail)
              "
              [matAutocomplete]="rowInspectorAuto"
              [disabled]="isRowLocked(element)"
              (input)="onRowInspectorInput(element.id, $event.target.value)"
              (focus)="onRowInspectorFocus(element.id)"
              type="text"
              matInput
            />
            <mat-autocomplete
              #rowInspectorAuto="matAutocomplete"
              (optionSelected)="
                onRowInspectorSelected(element, $event.option.value, i)
              "
              (closed)="onRowInspectorClosed(element.id)"
            >
              @for (
                inspector of getFilteredInspectorsForRow(element.id);
                track $index
              ) {
                <mat-option [value]="inspector.email">
                  {{ inspector.name + " " + inspector.lastName }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="activity">
        <th class="header-label" *matHeaderCellDef mat-header-cell>Activity</th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-select
              [(ngModel)]="element.activityId"
              [disabled]="
                isRowLocked(element) ||
                (selectionHasDifferentInspectionIds() &&
                  selection.isSelected(element))
              "
              (selectionChange)="
                changeAllSelectedRows(element, 'activityId');
                matchActivityIdWithActivityName(element);
                checkValidityAndSave(i, 'activityId')
              "
            >
              @for (activity of getActivityValues(element); track activity.id) {
                <mat-option [value]="activity.id">{{
                  activity.name
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="itemType">
        <th class="header-label" *matHeaderCellDef mat-header-cell>
          Item Type
        </th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-select
              [(ngModel)]="element.itemType"
              [disabled]="isRowLocked(element)"
              (selectionChange)="
                changeAllSelectedRows(element, 'itemType');
                checkValidityAndSave(i, 'itemType')
              "
            >
              @for (itemType of itemTypes(); track itemType.id) {
                <mat-option [value]="itemType.id">{{
                  itemType.name
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="numberOfItems">
        <th class="header-label" *matHeaderCellDef mat-header-cell>
          Nu. of Items
        </th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              [(ngModel)]="element.numberOfItems"
              [disabled]="isRowLocked(element)"
              [style.text-align]="'right'"
              [maxLength]="6"
              (keypress)="onlyNumbers($event)"
              (input)="changeAllSelectedRows(element, 'numberOfItems')"
              (blur)="checkValidityAndSave(i, 'numberOfItems')"
              (paste)="preventPaste($event)"
              matInput
            />
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="dayShiftHours">
        <th class="header-label" *matHeaderCellDef mat-header-cell>
          Day Shift Hours
        </th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field
            [ngClass]="{
              'error-color':
                element.validityError ==
                  TimesheetActivityError.InvalidHoursMoreThanAllowed &&
                greaterThanAllowedShift(element.dayShiftHours),
            }"
            appearance="outline"
            subscriptSizing="dynamic"
          >
            <input
              [(ngModel)]="element.dayShiftHours"
              [disabled]="isRowLocked(element)"
              (keypress)="onlyNumbers($event)"
              (blur)="
                formatTimeString(element, 'dayShiftHours');
                changeAllSelectedRows(element, 'dayShiftHours');
                checkValidityAndSave(i, 'dayShiftHours')
              "
              matInput
            />
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="nightShiftHours">
        <th class="header-label" *matHeaderCellDef mat-header-cell>
          Night Shift Hours
        </th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field
            [ngClass]="{
              'error-color':
                element.validityError ==
                  TimesheetActivityError.InvalidHoursMoreThanAllowed &&
                greaterThanAllowedShift(element.nightShiftHours),
            }"
            appearance="outline"
            subscriptSizing="dynamic"
          >
            <input
              [(ngModel)]="element.nightShiftHours"
              [disabled]="isRowLocked(element)"
              (keypress)="onlyNumbers($event)"
              (blur)="
                formatTimeString(element, 'nightShiftHours');
                changeAllSelectedRows(element, 'nightShiftHours');
                checkValidityAndSave(i, 'nightShiftHours')
              "
              matInput
            />
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="overtimeHours">
        <th class="header-label" *matHeaderCellDef mat-header-cell>
          Overtime Hours
        </th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              [(ngModel)]="element.overtimeHours"
              [disabled]="isRowLocked(element)"
              (keypress)="onlyNumbers($event)"
              (blur)="
                formatTimeString(element, 'overtimeHours');
                changeAllSelectedRows(element, 'overtimeHours');
                checkValidityAndSave(i, 'overtimeHours')
              "
              matInput
            />
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="doubleShiftHours">
        <th class="header-label" *matHeaderCellDef mat-header-cell>
          Double Shift Hours
        </th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              [(ngModel)]="element.doubleShiftHours"
              [disabled]="isRowLocked(element)"
              (keypress)="onlyNumbers($event)"
              (blur)="
                formatTimeString(element, 'doubleShiftHours');
                changeAllSelectedRows(element, 'doubleShiftHours');
                checkValidityAndSave(i, 'doubleShiftHours')
              "
              matInput
            />
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th class="header-label" *matHeaderCellDef mat-header-cell>Status</th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-select
              [(ngModel)]="element.status"
              (selectionChange)="
                changeAllSelectedRows(element, 'status');
                checkValidityAndSave(i, 'status')
              "
            >
              @for (status of statuses(); track status) {
                @if (getStatusLabel(status) !== "All") {
                  <mat-option
                    [value]="status"
                    [disabled]="isStatusOptionDisabled(element.status, status)"
                    >{{ getStatusLabel(status) }}</mat-option
                  >
                }
              }
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="remarks">
        <th class="header-label" *matHeaderCellDef mat-header-cell>Remarks</th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              [(ngModel)]="element.remarks"
              [disabled]="isRowLocked(element)"
              [maxlength]="100"
              (input)="changeAllSelectedRows(element, 'remarks')"
              (blur)="checkValidityAndSave(i, 'remarks')"
              matTooltip="{{ element.remarks }}"
              matInput
            />
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th class="header-label" *matHeaderCellDef mat-header-cell>Actions</th>
        <td *matCellDef="let element" mat-cell>
          <button [matMenuTriggerFor]="menu" matIconButton>
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button
              class="action-button"
              [disabled]="element.id === ''"
              [disabled]="selection.hasValue()"
              (click)="cloneTimesheetActivity(element)"
              mat-menu-item
            >
              <mat-icon class="action-icon-size">content_copy</mat-icon>
              <span class="action-size">Clone</span>
            </button>
            <button
              class="action-button"
              [disabled]="element.id === '' || isRowLocked(element)"
              (click)="openDeleteConfirmDialog(element)"
              mat-menu-item
            >
              <mat-icon class="action-icon-size">delete</mat-icon>
              <span class="action-size delete-action">Delete</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr
        *matHeaderRowDef="displayedColumns(); sticky: true"
        mat-header-row
      ></tr>
      <tr
        *matRowDef="let row; columns: displayedColumns()"
        [ngClass]="{
          'row-not-valid': !row.isValid,
          'row-selected': row.isValid && selection.selected.includes(row),
        }"
        mat-row
      ></tr>
    </mat-table>
  </div>
</div>

@if (isLoading()) {
  <div class="spinner-container">
    <mat-progress-spinner [diameter]="50" color="primary" mode="indeterminate">
    </mat-progress-spinner>
  </div>
}
